import { useState, useEffect } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { useAppContext } from "../../../../context/AppContext";

import Panel from "../../../../components/panel/panel";
import ExportTable from "../../../../components/button/ExportButton";
import { formatDate } from "../../../../utils/formatDate";

export const Table = ({
  dataTable,
  selectedCustomers,
  setSelectedCustomers,
}) => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [tableToExport, setTableToExport] = useState(null);
  const { nomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);

  const [selectAll, setSelectAll] = useState(false);
  const [totalRecords] = useState(0);

  const columns = [
    { field: "id", header: "Cod" },
    { field: "name_cli", header: "Cliente" },
    {
      field: "block_land",
      header: `${nomenclature[0].value}/${nomenclature[1].value}`,
    },
    {
      field: "created_at",
      header: "Data da Venda",
      body: (rowData) => formatDate(rowData.created_at),
    },
    {
      field: "date_readjust",
      header: "Data Último Reajuste",
      body: (rowData) => {
        const formattedDate = formatDate(rowData.date_readjust);
        const ExtensionType =
          rowData.type_readjust == "monthly" ? "Mensal" : "Anual";
        const typeReadjust = rowData.type_readjust
          ? " (" + ExtensionType + ")"
          : "";
        return formattedDate + typeReadjust;
      },
    },
  ];

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const onSelectionChange = (event) => {
    const value = event.value;
    setSelectedCustomers(value);
    setSelectAll(value.length === dataTable.length);
  };

  const onSelectAllChange = (event) => {
    setSelectAll(event.checked);

    if (event.checked) {
      setSelectedCustomers(dataTable);
    } else {
      setSelectedCustomers([]);
    }
  };

  useEffect(() => {
    if (dataTable) {
      // console.log("tabela", dataTable);
      const dataWithoutIds = dataTable.map((t) => ({
        Codigo: t.id,
        Cliente: t.name_cli,
        QuadraLote: t.block_land,
        DataVenda: t.created_at,
        DataReajuste: t.date_readjust,
      }));

      // console.log("sem ids", dataWithoutIds);
      setTableToExport(dataWithoutIds);
    }
  }, [dataTable]);

  return (
    <Panel mainCss="mt-4">
      <>
        <div className="px-2 pb-3">
          <ExportTable
            tableData={tableToExport}
            exportColumns={exportColumns}
            tabelaKey="Relatório de Ajuste de Contrato"
            globalFilterValue={globalFilterValue}
            onGlobalFilterChange={(e) => setGlobalFilterValue(e.target.value)}
          />
          <DataTable
            rows={25}
            paginator
            stripedRows
            showGridlines
            sortMode="multiple"
            selectionMode="multiple"
            rowsPerPageOptions={[5, 25, 100]}
            value={dataTable}
            totalRecords={dataTable}
            selectAll={selectAll}
            selection={selectedCustomers}
            onSelectionChange={onSelectionChange}
            onSelectAllChange={onSelectAllChange}
            globalFilter={globalFilterValue}
            emptyMessage="Nenhuma Informação foi encontrada."
            tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
          >
            <Column
              field="id"
              headerStyle={{ width: "3rem" }}
              selectionMode="multiple"
              // filterMatchMode={FilterMatchMode.CONTAINS}
            />
            {columns.map((col, i) => (
              <Column
                sortable
                body={col.body}
                key={i}
                style={{ minWidth: 150 }}
                field={col.field}
                header={col.header}
              />
            ))}
          </DataTable>
        </div>
      </>
    </Panel>
  );
};
